import { render, staticRenderFns } from "./CertificadoCapturar.vue?vue&type=template&id=669f1e0a"
import script from "./CertificadoCapturar.vue?vue&type=script&lang=js"
export * from "./CertificadoCapturar.vue?vue&type=script&lang=js"
import style0 from "~/../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CertificadoCapturar.vue?vue&type=style&index=1&id=669f1e0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports